/** "Not a fit, in the agent's view", one collapsible group per reason (Sofia, Oct 23 2026). */
import type { ReactNode } from 'react';
import type { OutreachCandidate } from '../../types/taOutreach';
import { misfitGroups } from './misfitGroups';

export function MisfitList({ misfits, renderCard }: { misfits: OutreachCandidate[]; renderCard: (c: OutreachCandidate) => ReactNode }) {
  if (!misfits.length) return null;
  return (
    <details>
      <summary className="cursor-pointer font-semibold">Not a fit, in the agent’s view ({misfits.length})</summary>
      <div className="mt-2 space-y-2">
        {misfitGroups(misfits).map((g) => (
          <details key={g.key} className="rounded-md border border-[#E8E8E8] px-3 py-2">
            <summary className="cursor-pointer text-[13px] font-semibold">
              {g.title} <span className="text-xs font-normal text-[#979797]">{g.people.length}</span>
            </summary>
            <div className="mt-2 space-y-3">{g.people.map(renderCard)}</div>
          </details>
        ))}
      </div>
    </details>
  );
}
